import React from "react";
import { PaginationComponentProps } from "react-data-table-component";
import { IonIcon } from "@ionic/react";
import { arrowBackCircleOutline, arrowForwardCircleOutline } from "ionicons/icons";
 
const CustomPaginationArrows = ({
  rowsPerPage,
  rowCount,
  onChangePage,
  currentPage,
}: PaginationComponentProps) => {
  const totalPages = Math.ceil(rowCount / rowsPerPage);
 
  const handlePrevious = () => {
    if (currentPage > 1) {
      onChangePage(currentPage - 1, rowsPerPage);
    }
  };
 
  const handleNext = () => {
    if (currentPage < totalPages) {
      onChangePage(currentPage + 1, rowsPerPage);
    }
  };
 
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        padding: "1rem",
        gap: "0.5rem",
      }}
    >
      <button
        onClick={handlePrevious}
        disabled={currentPage === 1}
        style={{
          background: "none",
          border: "none",
          cursor: currentPage === 1 ? "not-allowed" : "pointer",
        }}
      >
        <IonIcon
          icon={arrowBackCircleOutline}
          style={{
            fontSize: "36px",
            color: "#576f9f",
            opacity: currentPage === 1 ? 0.5 : 1,
          }}
        />
      </button>
 
      <button
        onClick={handleNext}
        disabled={currentPage === totalPages}
        style={{
          background: "none",
          border: "none",
          cursor: currentPage === totalPages ? "not-allowed" : "pointer",
        }}
      >
        <IonIcon
          icon={arrowForwardCircleOutline}
          style={{
            fontSize: "36px",
            color: "#576f9f",
            opacity: currentPage === totalPages ? 0.5 : 1,
          }}
        />
      </button>
    </div>
  );
};
 
export default CustomPaginationArrows;
 
 